import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router';
import { connect, ReactReduxContext } from 'react-redux';

var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
var onLocationChanged = function onLocationChanged(location, action) {
  return {
    type: LOCATION_CHANGE,
    payload: {
      location: location,
      action: action
    }
  };
};
var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
};
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var ConnectedRouter =
function (_React$Component) {
  _inherits(ConnectedRouter, _React$Component);
  function ConnectedRouter(props) {
    var _this;
    _classCallCheck(this, ConnectedRouter);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectedRouter).call(this, props));
    var _this$props = _this.props,
        history = _this$props.history,
        onChanged = _this$props.onLocationChanged,
        store = _this$props.store;
    _this.inTimeTravelling = false;
    _this.unsubscribe = store.subscribe(function () {
      var _store$getState$route = store.getState().router.location,
          pathnameInStore = _store$getState$route.pathname,
          searchInStore = _store$getState$route.search,
          hashInStore = _store$getState$route.hash;
      var _history$location = history.location,
          pathnameInHistory = _history$location.pathname,
          searchInHistory = _history$location.search,
          hashInHistory = _history$location.hash;
      if (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore) {
        _this.inTimeTravelling = true;
        history.push({
          pathname: pathnameInStore,
          search: searchInStore,
          hash: hashInStore
        });
      }
    });
    var handleLocationChange = function handleLocationChange(location, action) {
      if (!_this.inTimeTravelling) {
        onChanged(location, action);
      } else {
        _this.inTimeTravelling = false;
      }
    };
    _this.unlisten = history.listen(handleLocationChange);
    handleLocationChange(history.location, history.action);
    return _this;
  }
  _createClass(ConnectedRouter, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
      this.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          history = _this$props2.history;
      return React.createElement(Router, {
        history: history
      }, children);
    }
  }]);
  return ConnectedRouter;
}(React.Component);
_defineProperty(ConnectedRouter, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  history: PropTypes.shape({
    action: PropTypes.string.isRequired,
    listen: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired,
  onLocationChanged: PropTypes.func.isRequired,
  store: PropTypes.shape({
    getState: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired
  }).isRequired
});
var mapStateToProps = function mapStateToProps(_ref) {
  var router = _ref.router;
  return {
    action: router.action,
    location: router.location
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLocationChanged: function onLocationChanged$$1(location, action) {
      return dispatch(onLocationChanged(location, action));
    }
  };
};
var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
  var context = props.context;
  var Context = context || ReactReduxContext;
  if (Context == null) {
    throw new Error('Please upgrade to react-redux v6');
  }
  return React.createElement(Context.Consumer, null, function (_ref2) {
    var store = _ref2.store;
    return React.createElement(ConnectedRouter, _extends({
      store: store
    }, props));
  });
};
ConnectedRouterWithContext.propTypes = {
  context: PropTypes.object
};
var ConnectedRouter$1 = connect(mapStateToProps, mapDispatchToProps)(ConnectedRouterWithContext);

var routerMiddleware = function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== CALL_HISTORY_METHOD) {
          next(action);
          return;
        }
        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;
        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

var reducer = (function (history) {
  var initialRouterState = {
    location: history.location,
    action: history.action
  };
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        type = _ref.type,
        payload = _ref.payload;
    if (type === LOCATION_CHANGE) {
      return _objectSpread({}, state, payload);
    }
    return state;
  };
});

export { ConnectedRouter$1 as ConnectedRouter, routerMiddleware, reducer as connectRouter, LOCATION_CHANGE, CALL_HISTORY_METHOD, onLocationChanged, push, replace, go, goBack, goForward };
